module.exports = __webpack_public_path__ + "img/model-slogan-mobile.424c0f04.png";